<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div mat-dialog-content>
  The refresh tokens cache has been expired. Please <a class="simple-link" routerLink="/account/login">Re-Login</a>
</div>